import React, { useMemo, useState } from 'react';
import { X } from 'lucide-react';

function DistrictMultiSelect({ districts = [], selected = [], onChange }) {
  const [nextDistrict, setNextDistrict] = useState('');
  const selectedSet = useMemo(() => new Set(selected), [selected]);
  const available = districts.filter((district) => !selectedSet.has(district.name));

  function addDistrict(value) {
    if (!value || selectedSet.has(value)) return;
    onChange([...selected, value]);
    setNextDistrict('');
  }

  function removeDistrict(value) {
    onChange(selected.filter((item) => item !== value));
  }

  return (
    <div>
      <div className="mb-2 flex flex-wrap gap-1">
        {selected.map((district) => (
          <span
            key={district}
            className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-700"
          >
            {district}
            <button type="button" onClick={() => removeDistrict(district)} className="text-slate-500">
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
        {!selected.length && <span className="text-xs text-slate-400">Sin distritos preferidos</span>}
      </div>
      <select
        value={nextDistrict}
        onChange={(event) => {
          setNextDistrict(event.target.value);
          addDistrict(event.target.value);
        }}
        className="w-full rounded-lg border border-slate-200 px-2 py-2 text-sm"
      >
        <option value="">Agregar distrito</option>
        {available.map((district) => (
          <option key={district.slug || district.name} value={district.name}>
            {district.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DistrictMultiSelect;
